import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const manageAppsRoute: InvariantJiraRoute = {
	name: 'global-settings-addons-upm',
	path: '/plugins/servlet/upm',
};
